<template>
  <div id="zhugekongmingchentanxiang">
    <NavBar />

    <div id="hero" class="hero overlay subpage-hero">
      <div class="hero-content">
        <div class="hero-text">
          <h1>諸葛孔明沉檀香</h1>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">首页</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/products">产品</router-link>
            </li>
            <li class="breadcrumb-item active">諸葛孔明沉檀香</li>
          </ol>
        </div>
        <!-- /.hero-text -->
      </div>
      <!-- /.hero-content -->
    </div>
    <!-- /.hero -->

    <main id="main" class="site-main">
      <section class="site-section subpage-site-section section-project">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-4">
              <div class="project-img">
                <img
                  :src="
                    require('@/assets/img/products/zhu-ge-kong-ming-chen-tan-xiang.jpg')
                  "
                  class="img-res mx-auto"
                  alt=""
                />
              </div>
              <!-- /.project-img -->
            </div>
            <aside class="col-md-12">
              <div class="project-info text-justify">
                <h5>『諸葛孔明沉檀香』</h5>

                <p class="project-description">
                  此沉檀香絕對無添加任何化學添加劑，所以點燃之後
                  味道清香、柔香不刺激眼睛和鼻子。
                </p>

                <p class="project-description">
                  檀香，佛家謂之「旃檀」，意思是「與樂」
                  、「給人愉悅」。如「慧琳 音義」所記：
                  “「旃檀，此雲與樂，謂白檀能治熱病，赤檀能去風腫，
                  皆是除疾身安之樂，故名與樂也」
                  。”素有「香料之王」、「綠色黃金」
                  的美譽。它取自檀香料喬木檀香樹的木質心材(或其樹脂），愈近樹心與根部的材
                  質愈好。常製成木粉、木條、木塊等或提煉成檀香精油。用檀香製香歷來被奉為珍
                  品。
                </p>

                <p class="project-description">
                  從醫學角來說檀香還是一味重要的中藥材，歷來為醫家所重視，謂之「辛，溫；歸脾、
                  胃、心、肺經；行心溫中，開胃止痛」。外敷可以消炎去腫，滋潤肌膚；熏燒可殺菌消
                  毒，驅瘟辟疫。能治療喉嚨痛、粉刺、抗感染、抗氣喘。有調理敏感膚質，防止肌膚老化
                  的功效。去邪、去燥、殺菌、防霉、防蟲、防蛀。具有安撫神經，輔助冥思、提神靜心之
                  功效。
                </p>

                <p class="project-description">
                  也因如此，學佛之人，都以點燃檀香輔助冥思進入空明的境界，達至天人合-。
                </p>

                <p class="project-description">
                  還有那香插若經過檀香之香熏七七四十九天過後，可以將它帶在身上，出入可保平安！
                  也可增加正能量和運氣。
                </p>

                <p class="project-description">
                  所謂老檀香是指曾被埋在地下百年以上才出士的檀香，同時受到多百年的日月精華的育
                  化，可說己到達通靈的境界！本公司將其製成香枝，再由高僧誦經淨化，可直通天界，將
                  其點燃有一舉兩得的功能，除可以淨化心靈，提昇情操，還可進而到達天人合一的境界。
                </p>
              </div>
              <!-- /.project-description -->
            </aside>
          </div>
        </div>
      </section>
      <!-- /.section-project -->

      <RelatedProduct productCode="zhu-ge-kong-ming-chen-tan-xiang" />
    </main>
    <!-- /#main -->

    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
import NavBar from "../partials/NavBar.vue";
import Footer from "../partials/Footer.vue";
import RelatedProduct from "./RelatedProduct.vue";

export default {
  name: "ZhuGeKongMingChenTanXiang",
  data() {
    return {};
  },
  components: {
    NavBar,
    Footer,
    RelatedProduct
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/components/products/ZhuGeKongMingChenTanXiang.vue